module.exports = __webpack_public_path__ + "static/img/3.2c60b52.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/3.png
// module id = wrBg
// module chunks = 0